import { useState } from "react";
import { useAuth, api } from "@/App";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { EyeOff } from "lucide-react";
import { useLocale } from "@/i18n/LocaleContext";

export default function IncognitoCard() {
  const { t } = useLocale();
  const { user, updateUser } = useAuth();
  const [saving, setSaving] = useState(false);
  const incognito = user?.incognito === true;
  const hiddenCount = (user?.hidden_from || []).length;

  const save = async (checked) => {
    setSaving(true);
    try {
      const response = await api.put("/users/profile", { incognito: checked });
      updateUser(response.data);
      toast.success(checked ? t("incog.on") : t("incog.off"));
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to save");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="glass-card p-6 mt-6" data-testid="incognito-card">
      <div className="flex items-center gap-3 mb-3">
        <EyeOff className="w-5 h-5 text-primary" />
        <h3 className="text-lg font-semibold">{t("incog.title")}</h3>
      </div>
      <p className="text-sm text-muted-foreground mb-5">
        {t("incog.desc")}
      </p>

      <div className="flex items-center justify-between gap-4">
        <div>
          <Label htmlFor="incognito-toggle" className="font-medium cursor-pointer">
            {t("incog.toggleLabel")}
          </Label>
          <p className="text-xs text-muted-foreground mt-1">
            {t("incog.toggleDesc")}
          </p>
        </div>
        <Switch
          id="incognito-toggle"
          checked={incognito}
          disabled={saving}
          onCheckedChange={save}
          data-testid="incognito-switch"
        />
      </div>

      {hiddenCount > 0 && (
        <p className="text-xs text-muted-foreground mt-4 pt-4 border-t border-white/10" data-testid="hidden-from-count">
          {t("incog.hiddenFrom", { n: hiddenCount })}
        </p>
      )}
    </div>
  );
}
